import { render, staticRenderFns } from "./ConferencePolice.vue?vue&type=template&id=f52ade6a"
import script from "./ConferencePolice.vue?vue&type=script&lang=js"
export * from "./ConferencePolice.vue?vue&type=script&lang=js"
import style0 from "./ConferencePolice.vue?vue&type=style&index=0&id=f52ade6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports